import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { policyTimeline } from '@/mocks/strategy';

export default function PolicyTimeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="政策时间轴"
            title="五大国家战略方向"
            subtitle="乡村振兴、数字乡村、县域商业、数据要素与人工智能应用服务商，构成九畴云铺的政策底座。"
          />
        </Reveal>

        <div className="mt-14 relative">
          <div className="absolute left-5 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-1/2"></div>

          <div className="space-y-8">
            {policyTimeline.map((item, i) => (
              <Reveal key={item.no} delay={i * 60}>
                <div
                  className={`relative flex ${
                    item.highlight ? 'md:justify-center' : i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  {/* 节点 */}
                  <div className="absolute left-5 md:left-1/2 -translate-x-1/2 z-10">
                    <div
                      className={`w-4 h-4 rounded-full ring-4 ring-background-50 ${
                        item.highlight ? 'bg-secondary-500' : 'bg-primary-500'
                      }`}
                    ></div>
                  </div>

                  {item.highlight ? (
                    <div className="ml-14 md:ml-0 md:w-full flex justify-center">
                      <div className="w-full md:w-[80%] p-6 rounded-lg border border-secondary-400 bg-secondary-50">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="px-2.5 py-1 rounded-full bg-secondary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                            {item.no}
                          </span>
                          <span className="text-xs text-secondary-700 font-medium whitespace-nowrap">
                            {item.tag}
                          </span>
                        </div>
                        <h3 className="mt-3 font-heading font-bold text-xl text-foreground-950">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                        <div className="mt-4 flex flex-wrap gap-2">
                          {item.keywords.map((k) => (
                            <span
                              key={k}
                              className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap"
                            >
                              {k}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="md:w-1/2 pl-14 md:pl-0 md:pr-14 md:text-right">
                        <div className="p-5 rounded-lg bg-background-50 border border-background-200">
                          <div className="flex items-center gap-2 md:justify-end flex-wrap">
                            <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
                              {item.no}
                            </span>
                            <h3 className="font-heading font-bold text-lg text-foreground-950">
                              {item.title}
                            </h3>
                          </div>
                          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                            {item.desc}
                          </p>
                          <div className="mt-3 flex flex-wrap gap-2 md:justify-end">
                            {item.keywords.map((k) => (
                              <span
                                key={k}
                                className="px-2.5 py-1 rounded-full bg-background-100 text-foreground-600 text-xs whitespace-nowrap"
                              >
                                {k}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="md:w-1/2"></div>
                    </>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}